export default "__VITE_ASSET__DB6PisI8__"